import React from 'react'
import { ManageCriteriaContainer } from '../../containers/SupportSystem/ManageCriteriaContainer'
export const ManageCriteriaPage = () => {
    return (
        <ManageCriteriaContainer />
    )
}
